import { motion, useScroll, useTransform } from "framer-motion";
import { LogoMark } from "./Logo";

const WORDS = ["New Construction Decks", "Covered Porches", "Siding", "Exterior Upgrades", "Composite & Hardwood", "Cable Railing", "Windows & Doors"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  const { scrollYProgress } = useScroll();
  const x = useTransform(scrollYProgress, [0, 1], ["0%", "-60%"]);
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden bg-[#F2F1ED] py-8 md:py-10">
      <motion.div style={{ x }}>
      <div className="marquee-track flex w-max items-center">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className={`whitespace-nowrap px-8 text-4xl tracking-tight md:text-6xl ${i % 2 ? "font-serif italic text-[#0A0A0A]/70" : "font-display font-bold text-[#0A0A0A]"}`}>{w}</span>
            <img src="/brand/newland-roofs-dark.png" alt="" aria-hidden="true" className="h-6 w-auto opacity-80 md:h-8" />
          </span>
        ))}
      </div>
      </motion.div>
    </div>
  );
};

export { LogoMark };
